

























import { defineComponent, reactive, ref,watch } from '@vue/composition-api'
import { Message } from 'element-ui'
import useRootSetting from '@/hooks/useRootSetting';
export default defineComponent({
  name: 'Import',
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
  },
  setup(props, { emit }) {
    const {getIsMobile} = useRootSetting()
    const upload = ref(null)
    const uploadInfoRef = ref(null)
    const upLoading = ref(false)
    const fileList = ref([])
    const action = ref(`${process.env.VUE_APP_NONE_API}/upload_excel.php`)
    const rules = reactive({
      fileId: [{
        required: true,
        message: '请上传文件',
        trigger: 'change'
      }]
    })
    const uploadInfo = reactive({
      fileId: ''
    })

    // const handleSubmit = () => {
    //   uploadInfoRef.value.validate(async (valid) => {
    //     if (valid) {
    //       emit('submit')
    //     }
    //   })
    // }
    const beforeUpload = (file) =>{
      // 仅允许 Excel 文件
      const isExcel =
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";

      if (!isExcel) {
        Message.error("只能上传 Excel 文件 (.xls/.xlsx)");
        return false;
      }

      return true;
    }
    const uploadSuc = (e) => {
      if(e.code == 200) {
        Message.success(e.msg)
        emit('uploadSuccess')
      }else if(e.code == 300) {
        Message.error(e.msg)
      }else if(e.code == 400) {
        fileList.value = []
        Message.error(e.msg)
      }
    }
    const cancelExcel = () => {
      uploadInfo.fileId = ''
    }
    const uploadFail = (e) => {
      console.log('上传失败', e)
    }
    //导入下载模板
    const handleDown = () => {
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['商品名称','型号', '品牌', '库存数量', '未税价格', '含税价格',
          '自定义价格','产地','包装','库房货位','进货日期','供应商','收票状态（1：已到，2：未到，3：未税）','收票发票号','备注'
        ]
        const filterVal = ['title','xhname', 'source', 'number', 'wshui',
          'hshui','zdyprice','address','baozhuang','kufang','settime','gongyingshang','spzt','spfph','beizhu'
        ]
        const data = [
          ["轴承", 16002, "SKF",10,100,80,'','','','','2019-01-15','大连嘉轴承运科技有限公司',1,'',''],
          ["轴承", 16002, "SKF",10,100,80,'','','','','2019-08-15','大连嘉轴承运科技有限公司111',1,'','']
        ]; // 示例数据
        (excel.export_json_to_excel as any)({
          header: tHeader,
          data,
          filename: '库存列表'
        })
      })
    }

    const handleClose = () => {
      emit('close')
    }

    watch(()=>props.dialog,(val)=>{
      if(val) {
        fileList.value = []
      }
    },{immediate:true})
    return {
      action,
      fileList,
      getIsMobile,
      upLoading,
      uploadInfoRef,
      upload,
      uploadInfo,
      rules,
      handleClose,
      beforeUpload,
      handleDown,
      uploadSuc,
      uploadFail,
      cancelExcel
    }
  }
})
